<div *ngIf="questions.length > 0">
  <div *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }">
    <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <div class="fieldset-wrapper" id="dv_mg_{{ firstQuestion?.UniqueNumber }}">
    <fieldset *ngIf="
        !(
          questions[0].isCQ &&
          ((questions[0].isGroupCQHide && questions[0].isNOGroupRule) ||
            (questions[0].isGroupRule && questions[0].isCQHide))
        )
      ">
      <legend class="matrix-legend sr-only">Form Section</legend>
      <div *ngIf="!isMobile" class="question-option-wrapper matrix-question"
        [ngClass]="{ 'question-border': imgQuestion?.QuestionImageAndMedia_1 == null && !isMobile }">
        <span [ngClass]="{
            'question-text': matrix?.isOverAllStyleApplied,
            'question-text-nb': !matrix?.isOverAllStyleApplied,
            'no-Qno': !isDisplayQno
          }" id="lbltitle_T{{ firstQuestion?.UniqueNumber }}">
          <span *ngIf="!questions[0].piping" [innerHTML]="matrix?.Mtitle | headerFooterHtml"></span>
          <span *ngIf="questions[0].piping" [innerHTML]="getMatrixTitle(matrix?.matrix_id) | headerFooterHtml"></span>
          <span *ngIf="matrix?.questiontip" class="tooltip_icon" appTooltip [dataContext]="matrix?.questiontip"
            [IsButtonPanel]="false" [qid]="firstQuestion?.UniqueNumber" tabindex="0"></span>
          <div *ngIf="
              imgQuestion?.hasMedia &&
              imgQuestion?.MediaText != null &&
              imgQuestion?.MediaText != ''
            " class="question-media-text">
            <span>[{{ imgQuestion?.MediaText }}]</span>
          </div>
        </span>
      </div>

      <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
        <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
          [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
        </app-question-image-and-media>
      </div>

      <ng-container *ngIf="!isDisplayedPipeMessage; else QuotaMessage">
        <div *ngIf="isMobile; else MatrixGrid">
          <div class="matrix-mobile-subQ-cont" *ngFor="let questionArr of questionsArray; let i = index">
            <legend class="question-option-wrapper">
              <span [ngClass]="{
                  'question-text': matrix?.isOverAllStyleApplied,
                  'question-text-nb': !matrix?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }" id="lbltitle_T{{ firstQuestion?.UniqueNumber }}">
                <span *ngIf="!questions[0].piping" [innerHTML]="matrix?.Mtitle | headerFooterHtml"></span>
                <span *ngIf="questions[0].piping"
                  [innerHTML]="getMatrixTitle(matrix?.matrix_id) | headerFooterHtml"></span>
                <span *ngIf="matrix?.questiontip" class="tooltip_icon" appTooltip [dataContext]="matrix?.questiontip"
                  [IsButtonPanel]="false" [qid]="firstQuestion?.UniqueNumber" tabindex="0"></span>
                <div *ngIf="
                    imgQuestion?.hasMedia &&
                    imgQuestion?.MediaText != null &&
                    imgQuestion?.MediaText != ''
                  " class="question-media-text">
                  <span>[{{ imgQuestion?.MediaText }}]</span>
                </div>
              </span>
            </legend>
            <div class="matrix-mobile-subQ" *ngFor="let question of questionArr; let j = index"
              [ngClass]="'matrix-mobile-subQ_' + GetGroupData(question.group_no).Matrix_id">
              <div *ngIf="j == 0" class="question-option-wrapper">
                <span [ngClass]="{
                    'question-text': matrix?.isOverAllStyleApplied,
                    'question-text-nb': !matrix?.isOverAllStyleApplied,
                    'no-Qno': !isDisplayQno
                  }">
                  <span *ngIf="isDisplayQno">{{ GetQuestionNumber(question.group_no) }}.</span>
                  <span [innerHTML]="GetGroupTitle(question.group_no)"></span>
                </span>
              </div>
              <!-- Radio Button -->
              <div [hidden]="question.isCQ && question.isCQHide" id="dv_{{ question?.UniqueNumber }}" *ngIf="
                  ((question.qtype == 'GR' || question.qtype == 'SR') && question.qsubtype != 2) ||
                  question.qtype == 'RG' ||
                  (question.qtype == 'RW' && question.qsubtype == 1)
                " class="question-data sunset" [ngClass]="
                  isSubmitted &&
                  question.mandatory &&
                  question.AnswerText == null &&
                  !question.IsDisabled
                    ? 'mandatory'
                    : ''
                ">
                <ng-container *ngIf="
                    question.qtype == 'RG' && question.qsubtype == 1 && isMobile;
                    else RadioControl
                  ">
                  <app-rating-scale [JsonData]="GetQuestionsString(question)" [isDisplaySubQno]="isDisplayQno"
                    [isDisplayQno]="false" [group]="GetGroupData(question.group_no)"
                    [isMandatoryUpfront]="question.isMandatoryStar" [isMobile]="true" [isNewParticipationButton]="true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-rating-scale>
                </ng-container>
                <ng-template #RadioControl>
                  <app-radio-button [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                    [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                    [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                    [group]="GetGroupData(question.group_no)" [radiolength]="MatrixQCount"
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-radio-button>
                </ng-template>
              </div>

              <!-- Like Dislike -->
              <div [hidden]="
                  question.isCQ &&
                  ((question.isGroupCQHide && question.isNOGroupRule) ||
                    (question.isGroupRule && question.isCQHide))
                " id="dv_{{ question?.UniqueNumber }}"
                *ngIf="(question.qtype == 'GR' || question.qtype == 'SR') && question.qsubtype == 2"
                class="question-data sunset" [ngClass]="
                  isSubmitted &&
                  question.mandatory &&
                  question.AnswerText == null &&
                  !question.IsDisabled
                    ? 'mandatory'
                    : ''
                ">
                <app-thumbs-up [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                  [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                  [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                  [group]="GetGroupData(question.group_no)" (ChangeAnswersData)="UpdateQuestionsData($event)">
                </app-thumbs-up>
              </div>

              <!-- Check Box -->
              <div [hidden]="
                  question.isCQ &&
                  ((question.isGroupCQHide && question.isNOGroupRule) ||
                    (question.isGroupRule && question.isCQHide))
                " id="dv_{{ question?.UniqueNumber }}" *ngIf="question.qtype == 'GC' || question.qtype == 'SC'"
                class="question-data sunset" [ngClass]="
                  isSubmitted &&
                  question.mandatory &&
                  question.AnswerText == null &&
                  !question.IsDisabled
                    ? 'mandatory'
                    : ''
                ">
                <app-check-box [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                  [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                  [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                  [group]="GetGroupData(question.group_no)" (ChangeAnswersData)="UpdateQuestionsData($event)">
                </app-check-box>
              </div>

              <!-- Drop Down -->
              <div [hidden]="
                  question.isCQ &&
                  ((question.isGroupCQHide && question.isNOGroupRule) ||
                    (question.isGroupRule && question.isCQHide))
                " id="dv_{{ question?.UniqueNumber }}"
                *ngIf="question.qtype == 'GD' || (question.qtype == 'RW' && question.qsubtype == 2)"
                class="question-data sunset" [ngClass]="
                  isSubmitted &&
                  question.mandatory &&
                  question.AnswerText == null &&
                  !question.IsDisabled
                    ? 'mandatory'
                    : ''
                ">
                <app-drop-down [JsonData]="GetQuestionsString(question)" [isGrid]="true" [isDisplayQno]="false"
                  [isDisplaySubQno]="isDisplayQno" [isMDD]="false" [isNonSearchable]="false"
                  [isMandatoryUpfront]="isMandatoryUpfront" [isNewParticipationButton]="true" [isStandAlone]="true"
                  [group]="GetGroupData(question.group_no)" [DropDown]="DropDown" [dropDownlength]="MatrixQCount"
                  (ChangeAnswersData)="UpdateQuestionsData($event)">
                </app-drop-down>
              </div>

              <!-- Text Box -->
              <div [hidden]="
                  question.isCQ &&
                  ((question.isGroupCQHide && question.isNOGroupRule) ||
                    (question.isGroupRule && question.isCQHide))
                " id="dv_{{ question?.UniqueNumber }}" *ngIf="question.qtype == 'T'" class="question-data sunset"
                [ngClass]="
                  isSubmitted &&
                  question.mandatory &&
                  question.AnswerText == null &&
                  !question.IsDisabled
                    ? 'mandatory'
                    : ''
                ">
                <app-text-box [JsonData]="GetQuestionsString(question)" [isGrid]="true" [isDisplayQno]="false"
                  [isDisplaySubQno]="isDisplayQno" [group]="GetGroupData(question.group_no)"
                  [isMandatoryUpfront]="isMandatoryUpfront" (ChangeAnswersData)="UpdateQuestionsData($event)"
                  [isMTB]="false">
                </app-text-box>
              </div>
            </div>
          </div>
        </div>

        <ng-template #MatrixGrid>
          <div class="fieldset-wrapper-scroll-cont" *ngIf="!isStandAloneGrid; else StandAloneGrid">
            <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
            <div class="fieldset-wrapper-scroll">
              <div style="display: table; width: 100%" class="answerParent">
                <div class="answer-option-wrapper matrix-grid multiquestion-matrix-grid main-matrix">
                  <!-- Main Table -->
                  <table id="{{ firstQuestion?.UniqueNumber }}_table" class="main-matrix-table" cellspacing="0"
                    cellpadding="0" role="presentation" [style.min-width]="GetTotalColumnWidth() + 'px'">
                    <!-- Main Answer SubQ -->
                    <tr class="matrix-main-subq" [ngStyle]="{ display: isEx ? 'none' : 'table-row' }">
                      <td *ngFor="let group of groups" class="matrix-subQ">
                        <span *ngIf="isDisplayQno" class="gridQuestionNo"><strong>{{ GetQuestionNumber(group.group_no)
                          }}.</strong></span>
                        <span id="lbl_MG_{{ group.group_no }}_Main_AnsSubQ"
                          [innerHTML]="group.gtitle | headerFooterHtml"></span>
                      </td>
                    </tr>

                    <!-- Main SubQ Col Header -->
                    <tr class="matrix-main-subq">
                      <td *ngFor="let group of groups; let i = index">
                        <table cellspacing="0" cellpadding="0" style="min-width: 100%; text-align: center"
                          class="sub-category-table" cellspacing="0" cellpadding="0" role="presentation">
                          <tr>
                            <td *ngFor="let answer of GetAnswerHeader(group.group_no); let k = index"
                              class="sub-category-td matrix-answer" [ngClass]="
                                GetQuestion(group.group_no).qtype == 'RG' &&
                                GetQuestion(group.group_no).qsubtype == 1
                                  ? 'matrixRatingTd'
                                  : ''
                              " [hidden]="answer?.isHide" style="vertical-align: bottom">
                              <ng-container *ngIf="answer.isNA && answer.value_text == ''; else normalHeader">
                                <span id="lbl_MG_{{ answer.value_id }}_AnsSubQ_{{ group.group_no }}"
                                  *ngIf="GetQuestion(group.group_no).qtype == 'RG'" [innerHTML]="
                                    RatingScaleHeaderText(GetQuestion(group.group_no), k, answer)
                                      | headerFooterHtml
                                  "></span>
                                <div [innerHTML]="answer.value_text | headerFooterHtml"></div>
                              </ng-container>

                              <ng-template #normalHeader>
                                <span *ngIf="GetQuestion(group.group_no).qtype == 'RG'" class="" [innerHTML]="
                                    RatingScaleHeaderText(GetQuestion(group.group_no), k, answer)
                                      | headerFooterHtml
                                  "></span>
                                <div id="lbl_MG_{{ answer.value_id }}_AnsSubQ_{{ group.group_no }}"
                                  [innerHTML]="answer.value_text | headerFooterHtml"></div>
                              </ng-template>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <!-- Normal Rows  -->
                    <tr *ngFor="
                        let questionArr of questionsArray;
                        let i = index;
                        let odd = odd;
                        let even = even
                      " [ngClass]="{ 'odd-row': odd, 'even-row': even }">
                      <td *ngFor="let question of questionArr; let j = index" [ngStyle]="{
                          width: matrix.isDisplayManage
                            ? GetColumnWidth(question.group_no) + 'px'
                            : ''
                        }" style="height: 1px" 
                        [ngClass]="{ 'disabled-question': isPostEditDisable(question)}">
                        <!-- Radio Button -->

                        <table cellspacing="0" cellpadding="0" *ngIf="
                            (question.qtype == 'GR' && question.qsubtype != 2) ||
                            question.qtype == 'RG' ||
                            (question.qtype == 'RW' && question.qsubtype == 1)
                          " style="width: 100%; height: 100%; padding: 0px 2px" role="presentation">
                          <tr role="radiogroup">
                            <td id="td_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix.QPos != 0
                              }" class="answer-option radio grid-border"
                              *ngFor="let answers of question?.Answers; let k = index"
                              [ngStyle]="{ display: answers.isHide ? 'none' : '' }">
                              <div [ngClass]="
                                  groups.length > 1 &&
                                  ((k == 0 && question.mandatory && isMandatoryUpfront) ||
                                    (k == 0 &&
                                      question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null))
                                    ? 'isMandatory matrix-grid-mandatory'
                                    : ''
                                "><span class="screen-read-only">This Question is Required</span></div>
                              <input type="radio" name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME"
                                [attr.name]="
                                  'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'
                                " [disabled]="question.IsDisabled"
                                (click)="RadioButtonSelectedValue(answers, question)"
                                (change)="nextQuestion($event.target)" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                  answers?.value_id
                                }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                                [attr.aria-labelledby]="
                                  'lbl_MG_' +
                                  question.group_no +
                                  '_Main_AnsSubQ lbl_MG_' +
                                  answers.value_id +
                                  '_AnsSubQ_' +
                                  question.group_no +
                                  ' lbl_MG_' +
                                  questionArr[0].UniqueNumber +
                                  '_SubQ'
                                " [attr.aria-required]="
                                  (question.mandatory && isMandatoryUpfront) ||
                                  (question.mandatory && isSubmitted && question.AnswerText == null)
                                " />

                              <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                  answers?.value_id
                                }}_ID" style="justify-content: center; height: 100%">
                                <span class="radio-btn structure"></span>
                                <span style="
                                  position: absolute; 
                                  width: 1px; 
                                  height: 1px; 
                                  padding: 0; 
                                  margin: -1px; 
                                  overflow: hidden; 
                                  clip: rect(0, 0, 0, 0); 
                                  white-space: nowrap; 
                                  border: 0;
                                ">
                                  Select answer {{ answers?.value_id }}
                                </span>
                              </label>
                            </td>
                          </tr>
                        </table>
                        <table cellspacing="0" cellpadding="0" *ngIf="question.qtype == 'GR' && question.qsubtype == 2"
                          style="width: 100%; height: 100%; padding: 0px 2px" role="presentation">
                          <tr role="radiogroup">
                            <td id="td_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix.QPos != 0
                              }" class="answer-option radio grid-border"
                              *ngFor="let answers of question?.Answers; let k = index"
                              [ngStyle]="{ display: answers.isHide ? 'none' : '' }" style="vertical-align: middle">
                              <div [ngClass]="
                                  groups.length > 1 &&
                                  ((k == 0 && question.mandatory && isMandatoryUpfront) ||
                                    (k == 0 &&
                                      question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null))
                                    ? 'isMandatory matrix-grid-mandatory'
                                    : ''
                                "><span class="screen-read-only">This Question is Required</span></div>

                              <div class="ld-box mg-ld" [ngClass]="question.IsDisabled ? 'disabled3' : ''">
                                <input type="radio" name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME"
                                  [attr.name]="
                                    'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'
                                  " [disabled]="question.IsDisabled"
                                  (click)="RadioButtonSelectedValue(answers, question)" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                    answers?.value_id
                                  }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                                  [attr.aria-labelledby]="
                                    'lbl_MG_' +
                                    question.group_no +
                                    '_Main_AnsSubQ lbl_MG_' +
                                    answers.value_id +
                                    '_AnsSubQ_' +
                                    question.group_no +
                                    ' lbl_MG_' +
                                    questionArr[0].UniqueNumber +
                                    '_SubQ'
                                  " [attr.aria-required]="
                                    (question.mandatory && isMandatoryUpfront) ||
                                    (question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null)
                                  " />

                                <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                                    answers?.value_id
                                  }}_ID" [ngClass]="
                                    answers?.value_id == 1
                                      ? 'ld-common like-box'
                                      : answers?.value_id == 2
                                        ? 'ld-common dislike-box'
                                        : ''
                                  " aria-hidden="true"></label>
                              </div>
                            </td>
                          </tr>
                        </table>

                        <!-- Check Box-->

                        <table cellspacing="0" cellpadding="0" *ngIf="question.qtype == 'GC'"
                          style="width: 100%; height: 100%; padding: 0px 2px" role="presentation">
                          <tr>
                            <td class="answer-option check grid-border" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix.QPos != 0
                              }" *ngFor="let answers of question?.Answers; let k = index"
                              [ngStyle]="{ display: answers.isHide ? 'none' : '' }">
                              <div [ngClass]="
                                  groups.length > 1 &&
                                  ((k == 0 && question.mandatory && isMandatoryUpfront) ||
                                    (k == 0 &&
                                      question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null))
                                    ? 'isMandatory matrix-grid-mandatory'
                                    : ''
                                "><span class="screen-read-only">This Question is Required</span></div>

                              <input type="checkbox" name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_NAME"
                                [attr.name]="
                                  'Q' + question?.qno + '_' + question?.UniqueNumber + '_C_NAME'
                                " [disabled]="question.IsDisabled" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns" (change)="
                                  CheckBoxSelectedValue(answers, $event.target.checked, question)
                                " [attr.aria-labelledby]="
                                  'lbl_MG_' +
                                  question.group_no +
                                  '_Main_AnsSubQ lbl_MG_' +
                                  answers.value_id +
                                  '_AnsSubQ_' +
                                  question.group_no +
                                  ' lbl_MG_' +
                                  questionArr[0].UniqueNumber +
                                  '_SubQ'
                                " [attr.aria-required]="
                                  (question.mandatory && isMandatoryUpfront) ||
                                  (question.mandatory && isSubmitted && question.AnswerText == null)
                                " />

                              <label for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_C_{{
                                  answers?.value_id
                                }}_ID" [ngClass]="answers.ControlAns ? 'selectedAnsOpt' : ''"
                                style="justify-content: center; height: 100%">
                                <span class="check-btn structure"></span>
                                <span style="
                                  position: absolute; 
                                  width: 1px; 
                                  height: 1px; 
                                  padding: 0; 
                                  margin: -1px; 
                                  overflow: hidden; 
                                  clip: rect(0, 0, 0, 0); 
                                  white-space: nowrap; 
                                  border: 0;
                                ">
                                  Select answer {{ answers?.value_id }}
                                </span>
                              </label>
                            </td>
                          </tr>
                        </table>

                        <!-- Drop Down -->

                        <table cellspacing="0" cellpadding="0" *ngIf="
                            question.qtype == 'GD' ||
                            (question.qtype == 'RW' && question.qsubtype == 2)
                          " role="presentation" style="height: 100%; width: 100%; position: relative"
                          [style.zIndex]="questionsArray.length - i">
                          <tr>
                            <td class="answer-option check grid-border grid-hover"
                              style="vertical-align: middle; padding: 10px 10px; z-index: 0" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix.QPos != 0
                              }">
                              <div [ngClass]="
                                  groups.length > 1 &&
                                  ((question.mandatory && isMandatoryUpfront) ||
                                    (question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null))
                                    ? 'isMandatory matrix-grid-mandatory'
                                    : ''
                                "><span class="screen-read-only">This Question is Required</span></div>

                              <div class="custom-select-wrapper" [ngClass]="{ disabled: question.IsDisabled }"
                                *ngIf="question?.Answers.length < MDDdropDownCount">
                                <div _ngcontent-xlf-c17="" class="arr">
                                  <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                                </div>
                                <select (change)="
                                    DropDownSelectedValue($event, question, false);
                                    nextQuestion($event.target)
                                  " [(ngModel)]="question.selectAnsValue" [disabled]="question.IsDisabled"
                                  [attr.aria-labelledby]="
                                    'lbl_MG_' +
                                    question.group_no +
                                    '_Main_AnsSubQ lbl_MG_' +
                                    questionArr[0].UniqueNumber +
                                    '_SubQ'
                                  " [attr.aria-required]="
                                    (question.mandatory && isMandatoryUpfront) ||
                                    (question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null)
                                  ">
                                  <option [value]="-1" selected [innerHTML]="DropDown | headerFooterHtml"></option>
                                  <option *ngFor="let answers of question?.Answers" [hidden]="answers?.isHide"
                                    [value]="answers.value_id">
                                    <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                                  </option>
                                </select>
                              </div>

                              <div class="custom-select-wrapper drill-down-search"
                                id="div_MDD_drilldown_{{ question.UniqueNumber }}"
                                *ngIf="question?.Answers.length >= MDDdropDownCount">
                                <div class="arr" (click)="showDDList($event)">
                                  <div class="arr-symbol"></div>
                                </div>
                                <input type="text" class="drill-down-input" placeholder="{{ surveyMessages.Search }}"
                                  (keydown)="filterDDSearch($event, question)"
                                  (click)="filterDDSearch($event, question)" (change)="filterDDSearch($event, question)"
                                  (blur)="setDDListItem($event, question)" (focus)="setPrevValue($event)"
                                  [(ngModel)]="question.AnswerText" [attr.aria-labelledby]="
                                    'lbl_MG_' +
                                    question.group_no +
                                    '_Main_AnsSubQ lbl_MG_' +
                                    questionArr[0].UniqueNumber +
                                    '_SubQ'
                                  " aria-label="Search" role="combobox" aria-haspopup="true"
                                  [attr.aria-owns]="'dropdown_list_' + question.UniqueNumber" aria-expanded="false"
                                  (keydown.esc)="closeDDList($event)" (keydown.alt.arrowdown)="showDDList($event)" />
                                <div id="dropdown_list_{{ question.UniqueNumber }}" class="drill-down-list" style="
                                    max-height: 70px;
                                    overflow: auto;
                                    z-index: 1000;
                                    text-align: left;
                                  " role="listbox" [attr.aria-labelledby]="
                                    'lbl_MG_' +
                                    question.group_no +
                                    '_Main_AnsSubQ lbl_MG_' +
                                    questionArr[0].UniqueNumber +
                                    '_SubQ'
                                  ">
                                  <div class="drill-down-list-item" *ngFor="let answers of question?.Answers"
                                    [attr.list-value]="answers.value_id" [ngClass]="{ ddItemHidden: answers?.isHide }"
                                    (mousedown)="selectDDListItem($event, question)"
                                    [attr.ogListValue]="answers.value_text">
                                    {{ answers.value_text }}
                                  </div>
                                </div>
                                <select (change)="DropDownSelectedValue($event, question, false)"
                                  [(ngModel)]="question.selectAnsValue" [attr.aria-labelledby]="
                                    'lbl_MG_' +
                                    question.group_no +
                                    '_Main_AnsSubQ lbl_MG_' +
                                    questionArr[0].UniqueNumber +
                                    '_SubQ'
                                  " tabindex="-1" aria-hidden="true">
                                  <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected></option>
                                  <option *ngFor="let answers of question?.Answers" [hidden]="answers?.isHide"
                                    [value]="answers.value_id">
                                    <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                                  </option>
                                </select>
                              </div>
                              <div style="display: none" class="drill-down-list-itemMessage_{{
                                  question?.UniqueNumber
                                }} drill-down-list-itemMessage">
                                <span>{{ Nomatchfound }}</span>
                              </div>
                            </td>
                          </tr>
                        </table>

                        <!-- Text Box -->

                        <table cellspacing="0" cellpadding="0" *ngIf="question.qtype == 'T'" role="presentation"
                          style="height: 100%" [ngStyle]="{ width: groups.length == 1 ? '95%' : '100%' }">
                          <tr>
                            <td class="answer-option check grid-border grid-hover"
                              style="vertical-align: middle; padding: 5px 10px 4px 10px" [ngClass]="{
                                'matrix-border':
                                  isSubmitted &&
                                  question.mandatory &&
                                  !question.IsDisabled &&
                                  question.AnswerText == null,
                                'grid-border-inverse': matrix.QPos != 0
                              }">
                              <div [ngClass]="
                                  groups.length > 1 &&
                                  ((question.mandatory && isMandatoryUpfront) ||
                                    (question.mandatory &&
                                      isSubmitted &&
                                      question.AnswerText == null))
                                    ? 'isMandatory matrix-grid-mandatory'
                                    : ''
                                "><span class="screen-read-only">This Question is Required</span></div>
                              <div *ngIf="question?.qsubtype == 0; else OtherValidation">
                                <ng-container *ngIf="
                                    GetGroupData(question.group_no).mgTextboxHeight == 0 ||
                                      GetGroupData(question.group_no).mgTextboxHeight == 1;
                                    else TextAreaControl
                                  ">
                                  <input type="text" class="ansopt-textbox" [disabled]="question.IsDisabled"
                                    (blur)="onBlurMethod(question)" [placeholder]="isEx ? 'Comments' : ''"
                                    id="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_ID"
                                    name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_NAME"
                                    [(ngModel)]="question.AnswerText" maxlength="{{
                                      question?.characterLimit ? question?.characterLimit : ''
                                    }}" [ngStyle]="{ width: groups.length == 1 ? '100%' : '95%' }"
                                    [attr.aria-labelledby]="
                                      'lbl_MG_' +
                                      question.group_no +
                                      '_Main_AnsSubQ lbl_MG_' +
                                      questionArr[0].UniqueNumber +
                                      '_SubQ'
                                    " [attr.aria-required]="
                                      (question.mandatory && isMandatoryUpfront) ||
                                      (question.mandatory &&
                                        isSubmitted &&
                                        question.AnswerText == null)
                                    " />
                                </ng-container>
                                <ng-template #TextAreaControl>
                                  <textarea style="box-sizing: border-box" [disabled]="question.IsDisabled"
                                    rows="{{ GetGroupData(question.group_no).mgTextboxHeight }}" cols="5"
                                    class="ansopt-textbox" [ngStyle]="{ width: groups.length == 1 ? '100%' : '95%' }"
                                    [placeholder]="isEx ? 'Comments' : ''" (blur)="onBlurMethod(question)"
                                    id="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_ID"
                                    name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_NAME"
                                    [(ngModel)]="question.AnswerText" maxlength="{{
                                      question?.characterLimit ? question?.characterLimit : ''
                                    }}" [attr.aria-labelledby]="
                                      'lbl_MG_' +
                                      question.group_no +
                                      '_Main_AnsSubQ lbl_MG_' +
                                      questionArr[0].UniqueNumber +
                                      '_SubQ'
                                    " [attr.aria-required]="
                                      (question.mandatory && isMandatoryUpfront) ||
                                      (question.mandatory &&
                                        isSubmitted &&
                                        question.AnswerText == null)
                                    ">
                                  </textarea>
                                </ng-template>
                              </div>
                              <ng-template #OtherValidation>
                                <div class="form-group">
                                  <ng-container *ngIf="
                                      GetGroupData(question.group_no).mgTextboxHeight == 0 ||
                                        GetGroupData(question.group_no).mgTextboxHeight == 1;
                                      else TextAreaControl
                                    ">
                                    <input type="text" id="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_ID"
                                      [disabled]="question.IsDisabled" maxlength="50" class="ansopt-textbox"
                                      [ngStyle]="{ width: groups.length == 1 ? '100%' : '95%' }" (blur)="
                                        ValidationForSubQuestionType(
                                          $event,
                                          $event.target.value,
                                          question
                                        )
                                      " name="Q{{ question?.qno }}_{{
                                        question?.UniqueNumber
                                      }}_T_NAME" [(ngModel)]="question.AnswerText" (keyup)="keyup(question)"
                                      #valid="ngModel" aria-label="textbox" [attr.aria-required]="
                                        (question.mandatory && isMandatoryUpfront) ||
                                        (question.mandatory &&
                                          isSubmitted &&
                                          question.AnswerText == null)
                                      " />
                                  </ng-container>
                                  <ng-template #TextAreaControl>
                                    <textarea style="box-sizing: border-box" [disabled]="question.IsDisabled"
                                      rows="{{ GetGroupData(question.group_no).mgTextboxHeight }}" cols="5"
                                      class="ansopt-textbox" [ngStyle]="{ width: groups.length == 1 ? '100%' : '95%' }"
                                      (blur)="
                                        ValidationForSubQuestionType(
                                          $event,
                                          $event.target.value,
                                          question
                                        )
                                      " id="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_T_ID" name="Q{{ question?.qno }}_{{
                                        question?.UniqueNumber
                                      }}_T_NAME" [(ngModel)]="question.AnswerText" (keyup)="keyup(question)"
                                      [attr.aria-required]="
                                        (question.mandatory && isMandatoryUpfront) ||
                                        (question.mandatory &&
                                          isSubmitted &&
                                          question.AnswerText == null)
                                      "></textarea>
                                  </ng-template>
                                </div>
                                <div *ngIf="question.isValid" class="validator_message" role="alert">
                                  {{ question.error_msg }}
                                </div>
                              </ng-template>
                              <div *ngIf="isEx && question?.Showcharlimit" style="margin: 0"
                                class="char-remain charraim">
                                {{ question?.RemainingChr }}: {{ remainingChar(question) }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <div *ngIf="isNgAfter && count == 0">{{ ngOnChangesEventHandle(i) }}</div>
                      <div *ngIf="i == questionsArray.length - 1">{{ setLastRowPadding() }}</div>
                    </tr>
                  </table>
                  <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
                    <div class="ques-response-btn-div">
                      <button *ngIf="
                          isNewParticipationButton &&
                          (!(
                            questions.length == 1 &&
                            (questions[0].qtype == 'GD' ||
                              questions[0].qtype == 'GR' ||
                              questions[0].qtype == 'RW' ||
                              questions[0].qtype == 'RG')
                          ) ||
                            !isAutoScroll) &&
                          isAnsChange
                        " type="button" class="ques-response-btn"
                        (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                        (click)="gotoNextQuestion(questions[0], $event.target)">
                        {{ newParticipationBtnText }}
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <ng-template #StandAloneGrid>
            <div class="question-option-wrapper">
              <span [ngClass]="{
                  'question-text': matrix?.isOverAllStyleApplied,
                  'question-text-nb': !matrix?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }">
                <span *ngIf="isDisplayQno">{{ GetQuestionNumber(groups[0].group_no) }}.</span>
                <span [innerHTML]="GetGroupTitle(groups[0].group_no)"></span>
              </span>
            </div>
            <div class="matrix-standalone">
              <ng-container *ngFor="let questionArr of questionsArray; let i = index">
                <div *ngFor="let question of questionArr; let j = index" [ngClass]="
                    j < questionArr.length
                      ? 'notLastStandAlone matrix-standalone-ques matrix-standalone-active-ques' +
                        question.group_no
                      : 'matrix-standalone-ques matrix-standalone-active-ques' + question.group_no
                  ">
                  <!-- Radio Button -->
                  <div [hidden]="
                      question.isCQ &&
                      ((question.isGroupCQHide && question.isNOGroupRule) ||
                        (question.isGroupRule && question.isCQHide))
                    " id="dv_{{ question?.UniqueNumber }}" *ngIf="
                      ((question.qtype == 'GR' || question.qtype == 'SR') &&
                        question.qsubtype != 2) ||
                      question.qtype == 'RG' ||
                      (question.qtype == 'RW' && question.qsubtype == 1)
                    " class="question-data sunset" [ngClass]="
                      isSubmitted &&
                      question.mandatory &&
                      question.AnswerText == null &&
                      !question.IsDisabled
                        ? 'mandatory'
                        : ''
                    ">
                    <app-radio-button [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                      [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                      [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                      [group]="GetGroupData(question.group_no)" [radiolength]="MatrixQCount"
                      (ChangeAnswersData)="UpdateQuestionsData($event)">
                    </app-radio-button>
                  </div>

                  <!-- Like Dislike -->
                  <div [hidden]="
                      question.isCQ &&
                      ((question.isGroupCQHide && question.isNOGroupRule) ||
                        (question.isGroupRule && question.isCQHide))
                    " id="dv_{{ question?.UniqueNumber }}" *ngIf="
                      (question.qtype == 'GR' || question.qtype == 'SR') && question.qsubtype == 2
                    " class="question-data sunset" [ngClass]="
                      isSubmitted &&
                      question.mandatory &&
                      question.AnswerText == null &&
                      !question.IsDisabled
                        ? 'mandatory'
                        : ''
                    ">
                    <app-thumbs-up [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                      [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                      [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                      [group]="GetGroupData(question.group_no)" (ChangeAnswersData)="UpdateQuestionsData($event)">
                    </app-thumbs-up>
                  </div>

                  <!-- Check Box -->
                  <div [hidden]="
                      question.isCQ &&
                      ((question.isGroupCQHide && question.isNOGroupRule) ||
                        (question.isGroupRule && question.isCQHide))
                    " id="dv_{{ question?.UniqueNumber }}" *ngIf="question.qtype == 'GC' || question.qtype == 'SC'"
                    class="question-data sunset" [ngClass]="
                      isSubmitted &&
                      question.mandatory &&
                      question.AnswerText == null &&
                      !question.IsDisabled
                        ? 'mandatory'
                        : ''
                    ">
                    <app-check-box [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                      [isDisplaySubQno]="isDisplayQno" [isMandatoryUpfront]="question.isMandatoryStar" [isGrid]="true"
                      [isNewParticipationButton]="true" [isStandAlone]="true" [isMobile]="false"
                      [group]="GetGroupData(question.group_no)" (ChangeAnswersData)="UpdateQuestionsData($event)">
                    </app-check-box>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>

      <ng-template #QuotaMessage>
        <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
      </ng-template>
    </fieldset>
  </div>
</div>